var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13C8.33 12.9999 9.62231 12.5581 10.674 11.744C11.7257 10.9299 12.4773 9.78954 12.8107 8.502M7 13C5.67001 12.9999 4.37769 12.5581 3.32598 11.744C2.27427 10.9299 1.52272 9.78954 1.18934 8.502M7 13C8.65667 13 10 10.3133 10 7C10 3.68667 8.65667 1 7 1M7 13C5.34334 13 4 10.3133 4 7C4 3.68667 5.34334 1 7 1M12.8107 8.502C12.934 8.022 13 7.51867 13 7C13.0016 5.96807 12.7359 4.95333 12.2287 4.05467M12.8107 8.502C11.0328 9.48759 9.0328 10.0032 7 10C4.892 10 2.91134 9.45667 1.18934 8.502M1.18934 8.502C1.06317 8.01132 0.999552 7.50665 1 7C1 5.93 1.28 4.92467 1.77134 4.05467M7 1C8.06416 0.999557 9.10928 1.28224 10.0281 1.81904C10.947 2.35585 11.7065 3.12744 12.2287 4.05467M7 1C5.93584 0.999557 4.89072 1.28224 3.97187 1.81904C3.05303 2.35585 2.29354 3.12744 1.77134 4.05467M12.2287 4.05467C10.7771 5.31195 8.92036 6.00276 7 6C5.00134 6 3.17334 5.26667 1.77134 4.05467",
    stroke: "#9499A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.e487452a220c771ca00bd2466d3da99c.svg";
export { ForwardRef as ReactComponent };